import { Controller } from "@hotwired/stimulus"
import URI from "urijs"

export default class extends Controller {
  static targets = ["tierRadio", "tierContainer", "splitCheckbox", "amountDisplay", "intervalDisplay", "originalAmountDisplay", "selectButton"]

  connect() {
    this.tierRadioTargets[0].checked = true
    this.toggle();
    // Initialize split checkbox state
    if (this.hasSplitCheckboxTarget) {
      this.splitCheckboxTargets.forEach(checkbox => {
        checkbox.checked = false
      })
    }
  }

  toggle() {
    this._toggleRadios()
    this._toggleTierContainers()
  }

  toggleSplit(event) {
    const isChecked = event.target.checked
    this._updateAmountDisplays(isChecked)
    this._updateSelectButtons(isChecked)
  }

  _updateSelectButtons(showSplit) {
    if (!this.hasSelectButtonTarget) return
    this.selectButtonTargets.forEach(button => {
      const href = showSplit ? button.dataset.splitPath : button.dataset.regularPath
      if (href) button.setAttribute("href", href)
    })
  }

  _updateAmountDisplays(showSplit) {
    this.amountDisplayTargets.forEach(element => {
      const amount = showSplit ? element.dataset.splitAmount : element.dataset.regularAmount
      element.textContent = amount
    })

    this.intervalDisplayTargets.forEach(element => {
      const interval = showSplit ? element.dataset.splitInterval : element.dataset.regularInterval
      element.innerHTML = interval
    })

    if (this.hasOriginalAmountDisplayTarget) {
      this.originalAmountDisplayTargets.forEach(element => {
        const originalAmount = showSplit ? element.dataset.splitOriginalAmount : element.dataset.regularOriginalAmount
        if (originalAmount) {
          element.textContent = originalAmount
        }
      })
    }
  }

  _toggleTierContainers() {
    this.tierContainerTargets.forEach(element => {
      element.classList.toggle("hidden", element.dataset.tier != this._selectedTier)
    })
  }

  _toggleRadios() {
    this.tierRadioTargets.forEach(element => {
      element.parentElement.classList.toggle("bg-primary", element.checked)
      element.parentElement.classList.toggle("text-white", element.checked)
    })
  }

  get _selectedTier() {
    let checkedRadio = this.tierRadioTargets.find(element => element.checked)
    return checkedRadio.value
  }
}
